import PropTypes from 'prop-types';
import React from 'react';
import css from './MultiColStepCard.css';
import StepCard from './StepCard';

const getChildrenCount = item => item.children?.length || 0;

const distributeItemsByChildrenCount = (items, columnsCount) => {
    const sorted = [...items].sort((a, b) => getChildrenCount(b) - getChildrenCount(a));
    const columnTotals = Array.from({ length: columnsCount }, () => 0);
    const columns = Array.from({ length: columnsCount }, () => []);

    sorted.forEach(item => {
        const count = getChildrenCount(item);
        const minColumnIndex = columnTotals.indexOf(Math.min(...columnTotals));
        columns[minColumnIndex].push(item);
        columnTotals[minColumnIndex] += count;
    });

    return columns;
};

const MultiColStepCard = ({ items, columnsCount = 2, ...props }) => {
    const columns = distributeItemsByChildrenCount(items, columnsCount);

    const renderColumn = columnItems => (
        <div className={css.column}>
            {columnItems.map(({ title, children }) => (
                <div key={title} className={css.item}>
                    <span className={css.title}>{title}</span>
                    {children}
                </div>
            ))}
        </div>
    );

    return (
        <StepCard {...props} className={css.stepCard}>
            <div className={css.content}>{columns.map(renderColumn)}</div>
        </StepCard>
    );
};

MultiColStepCard.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            children: PropTypes.arrayOf(PropTypes.node).isRequired,
        })
    ).isRequired,
    columnsCount: PropTypes.number,
};

export default MultiColStepCard;
